module.exports = __webpack_public_path__ + "img/儿童脚部成长发育预测.a63dc54c.png";